export function getUrlParams() {
  return new URLSearchParams(window.location.search);
}
